import * as lock from "../operations/lock_cell";

export function lockCell(row, column, state){
	lock.lockCell(this, row, column, state);
}

export function isCellLocked(row, column){
	return lock.isCellLocked(this, row, column);
}